export type PrixOriginState = 'manual' | 'db-prestation' | 'db-ensemble' | 'modified';

/**
 * Déduit l'état d'origine du prix à partir des champs de traçabilité du bloc.
 * Retourne null si aucune information d'origine n'est disponible.
 */
export function getPrixOriginState(
  prixUnitaireSource?: string,
  prixUnitaireMatchType?: string,
): PrixOriginState | null {
  if (!prixUnitaireSource) return null;

  if (prixUnitaireSource === 'database') {
    if (prixUnitaireMatchType === 'ensemble') return 'db-ensemble';
    return 'db-prestation'; // 'prestation' ou non défini → violet par défaut
  }

  if (prixUnitaireSource === 'user') {
    if (prixUnitaireMatchType) return 'modified'; // vient d'une DB, modifié ensuite
    return 'manual'; // saisi de zéro
  }

  return null;
}

/** Classe Tailwind de couleur de texte correspondant à l'état d'origine. */
export function getPrixOriginColor(state: PrixOriginState | null): string {
  switch (state) {
    case 'manual':        return 'text-gray-500';
    case 'db-prestation': return 'text-violet-600';
    case 'db-ensemble':   return 'text-blue-600';
    case 'modified':      return 'text-amber-600';
    default:              return '';
  }
}
